import type { getFrontendFlags } from '@unleash/nextjs';

export type FlagBootstrap = Awaited<ReturnType<typeof getFrontendFlags>>['toggles'];

// 서버 조회(getServerFlags)와 client FlagProvider 가 같은 Unleash 대상을 보도록 한 곳에 둔다.
export const UNLEASH_CONFIG = {
  appName: 'viewup-frontend',
  clientKey: process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN,
  url: process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL,
};
